module.exports = __webpack_public_path__ + "static/img/main_sub_menu01.01525c1a.svg";